"use client";

import React from 'react';
import Image from './Image';
import AdvantageLeft from '@/assets/images/advantageLeft.svg'
import AdvantageRight from '@/assets/images/advantageRight.svg'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper/core";
import { Mousewheel, Navigation } from 'swiper/modules';
import 'swiper/css';

SwiperCore.use([Mousewheel, Navigation]);

const Advantage = () => {

    return (
        <div 
          className='w-full h-[500px] bg-cover bg-center mt-24 flex items-center'
          data-aos="fade-up"
          data-aos-delay="300"
          data-aos-distance="1000px"
          data-aos-duration="300"
          data-aos-easing="ease-in-out"
        >
            <Image src={AdvantageLeft} width={150} className='absolute bottom-0 left-0' alt='AdvantageLeft'/>
            <Image src={AdvantageRight} width={150} className='absolute top-0 right-0' alt='AdvantageLeft'/>
            <div className='main_container'>
                <div className='flex gap-10 h-full'>
                    <div className='w-1/2 flex items-center '>
                        <div className='w-[360px] ml-auto'>
                            <p className='gradient_bg_text bg-grad-title text-[60px] leading-[62px] font-bold'>Our Advantage</p>
                            <p className='text-[17px] text-textColor mt-5'>By building a collective group of talent with a proven edge against multiple cycles onchain, we will cement ourselves into this industry as a long lasting operator for decades to come.</p>
                        </div>
                    </div>
                    <div className='w-1/2 flex items-center'>
                        <Swiper
                            className='h-[268px] w-[459px]'
                            navigation={false}
                            centeredSlides={true}
                            loop={true}
                            direction="vertical"
                            mousewheel={true}
                            spaceBetween={8}
                            slidesPerView={3}
                        >
                            <SwiperSlide>
                                <p className='text-textColor-100 text-[40px] font-medium text-center blur-sm'>Experience</p>
                            </SwiperSlide>
                            <SwiperSlide>
                                <p className='text-textColor-100 text-[40px] font-medium text-center blur-sm'>Network</p>
                            </SwiperSlide>
                            <SwiperSlide>
                                <p className='text-textColor-100 text-[40px] font-medium text-center blur-sm'>Macro</p>
                            </SwiperSlide>
                            <SwiperSlide>
                                <p className='text-textColor-100 text-[40px] font-medium text-center blur-sm'>Macro</p>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Advantage;